<template>
    <!--<el-tooltip  :disabled="tipdisable" class="item" effect="dark" :content="tipContent" placement="top">-->
        <el-input class="zmnuminput"
                  :placeholder="placeholder"
                  ref="input"
                  :value="currentInputValue"
                  :disabled="disabled"
                  :max="max"
                  :min="min"
                  :name="name"
                  :tabindex="tabindex"
                  :readonly="readonly"
                  @blur="handleBlur"
                  @focus="handleFocus"
                  @change="handleInputChange">
        </el-input>
    <!--</el-tooltip>-->
</template>

<script>
    export default {
        name: "ZmNumInput",
        props: {
            disabled:{
                type:Boolean,
                default:false
            },
            value:{
                type:[String,Number]
            },
            readonly:{
                type:Boolean,
                default:false
            },
            precision:{
                type:Number,
                default:0
            },
            min:{
                type:Number
            },
            max:{
                type:Number
            },
            tabindex:{
                type:String
            },
            name:{
                type:String
            },
            focusSelect:{
                type:Boolean,
                default:false
            },
            isDefaultPrecision:{
                type:Boolean,
                default:true
            },
            placeholder:String
        },
        data(){
            return {
                componentShow:true,
                currentValue:'',
                // tipdisable:true,
                // tipContent:'',
            }
        },
        computed:{
            currentInputValue() {
                const currentValue = this.currentValue;
                if (typeof currentValue === 'number' && this.precision !== undefined) {
                    if(this.isDefaultPrecision){
                        return currentValue.toFixed(this.precision);
                    }else{
                        let numPrecis = this.getNumPrecis(currentValue);
                        let tempPre = numPrecis < this.precision ? numPrecis : this.precision;
                        return currentValue.toFixed(tempPre);
                    }
                } else {
                    return currentValue;
                }
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    // let newVal = value === undefined ? value : Number(value);
                    let newVal = (value || value === 0) ? Number(value) : undefined;
                    if (newVal !== undefined ) {
                        if (isNaN(newVal)) {
                            return;
                        }
                        if (this.precision !== undefined) {
                            if(this.isDefaultPrecision){
                                newVal = this.toPrecision(newVal, this.precision);
                            } else {
                                let numPrecis = this.getNumPrecis(newVal);
                                let tempPre = numPrecis < this.precision ? numPrecis : this.precision;
                                newVal = this.toPrecision(newVal, tempPre);
                            }
                        }
                    }
                    if (newVal >= this.max) newVal = this.max;
                    if (newVal <= this.min) newVal = this.min;
                    this.currentValue = newVal;

                    // if(newVal){
                    //     this.tipdisable = false;
                    //     this.tipContent = (newVal).toFixed(this.precision).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                    // }else{
                    //     this.tipdisable = true;
                    //     this.tipContent = '';
                    // }

                    this.$emit('input', newVal);
                }
            }
        },
        methods: {
            getNumPrecis(num){
                if(num){
                    let x = String(num).indexOf('.');   //小数点的位置
                    if(x > -1){
                        return String(num).length - (x + 1);
                    }
                }
                return 0;
            },

            handleBlur(event) {
                // console.log('handleBlur')
                this.$emit('blur', event);
                this.$refs.input.setCurrentValue(this.currentInputValue);
            },
            handleFocus(event) {
                // console.log('handleFocus')
                this.$emit('focus', event);
            },
            toPrecision(num, precision) {
                // console.log('toPrecision')
                if (precision === undefined)
                    precision = this.numPrecision;
                return parseFloat(parseFloat(Number(num).toFixed(precision)));
            },
            handleInputChange(value) {
                // console.log('handleInputChange')
                const newVal = value === '' ? undefined : Number(value);
                if (!isNaN(newVal) || value === '') {
                    this.setCurrentValue(newVal);
                }
            },
            getPrecision(value) {
                // console.log('getPrecision')
                if (value === undefined) return 0;
                const valueString = value.toString();
                const dotPosition = valueString.indexOf('.');
                let precision = 0;
                if (dotPosition !== -1) {
                    precision = valueString.length - dotPosition - 1;
                }
                return precision;
            },
            numPrecision() {
                // console.log('numPrecision')
                const { value, step, getPrecision, precision } = this;
                const stepPrecision = getPrecision(step);
                if (precision !== undefined) {
                    if (stepPrecision > precision) {
                        console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
                    }
                    return precision;
                } else {
                    return Math.max(getPrecision(value), stepPrecision);
                }
            },

            setCurrentValue(newVal) {
                // console.log('setCurrentValue')
                const oldVal = this.currentValue;
                if (typeof newVal === 'number' && this.precision !== undefined) {
                    newVal = this.toPrecision(newVal, this.precision);
                }
                if (newVal >= this.max) newVal = this.max;
                if (newVal <= this.min) newVal = this.min;
                if (oldVal === newVal) {
                    this.$refs.input.setCurrentValue(this.currentInputValue);
                    return;
                }
                this.$emit('input', newVal);
                this.$emit('change', newVal, oldVal);
                this.currentValue = newVal;
            },
            focus(){
                this.$refs.input.focus();
            },
            select(){
                this.$refs.input.select();
            }
        },
        created(){
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    };
</script>


<style>
    .zmnuminput .el-input__inner {
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// ../../src/components/ZmNumInput/index.vue